export default __webpack_public_path__ + "static/Aventure_Video-88788adf19360e8642a3a30eca42e67b.mp4";